import { render } from "./MoboPlayer.vue?vue&type=template&id=745fb137&scoped=true"
import script from "./MoboPlayer.vue?vue&type=script&lang=js"
export * from "./MoboPlayer.vue?vue&type=script&lang=js"

import "./MoboPlayer.vue?vue&type=style&index=0&id=745fb137&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745fb137"]])

export default __exports__